import Codec from "./codec"
import { TeacherUsageStats } from "../domain/teacher-usage-stats"
import {
  AssignmentQuestionsWorkedOnCodec,
  AssignmentQuestionsWorkedOnResponse,
} from "./assignment-questions-worked-on-codec"

export interface TeacherUsageStatsResponse {
  user_id: string
  first_name: string
  last_name: string
  display_name: string
  is_pro: boolean
  last_login: string | undefined
  assignment_count: number | undefined
  assignments_worked_on_this_year: number | undefined
  assignment_questions_worked_on:
    | AssignmentQuestionsWorkedOnResponse
    | undefined
}

export class TeacherUsageStatsCodec extends Codec {
  public assignmentQuestionsWorkedOnCodec: AssignmentQuestionsWorkedOnCodec

  constructor() {
    super()

    this.assignmentQuestionsWorkedOnCodec =
      new AssignmentQuestionsWorkedOnCodec()
  }

  encode(value: TeacherUsageStats): TeacherUsageStatsResponse {
    return {
      user_id: value.userId,
      first_name: value.firstName,
      last_name: value.lastName,
      display_name: value.displayName,
      is_pro: value.isPro,
      last_login: value.lastLogin?.toISOString(),
      assignment_count: value.assignmentCount,
      assignments_worked_on_this_year: value.assignmentsWorkedOnThisYear,
      assignment_questions_worked_on: value.assignmentQuestionsWorkedOn
        ? this.assignmentQuestionsWorkedOnCodec.encode(
            value.assignmentQuestionsWorkedOn,
          )
        : undefined,
    }
  }

  decode(value: TeacherUsageStatsResponse | null): TeacherUsageStats | null {
    if (value) {
      return new TeacherUsageStats(
        value.user_id,
        value.first_name,
        value.last_name,
        value.display_name,
        value.is_pro,
        value.last_login ? new Date(value.last_login) : undefined,
        value.assignment_count,
        value.assignments_worked_on_this_year,
        value.assignment_questions_worked_on
          ? this.assignmentQuestionsWorkedOnCodec.decode(
              value.assignment_questions_worked_on,
            )
          : undefined,
      )
    }
    return null
  }
}
